import { L as Loader } from './index-DimvNaNS.js';
import { z, T, s as s$2, x } from './index-BvoALBv3.js';
import { f as formatMoney } from './currency-BS0riN3f.js';
import { search_icon, back_icon, location_icon, clock_icon, chevron_down_icon, phone_icon, mail_icon } from './triton-x-icons.js';

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const{I:t$1}=z,i$1=o=>null===o||"object"!=typeof o&&"function"!=typeof o,n$2={HTML:1,SVG:2},e$2=(o,t)=>void 0===t?void 0!==o?._$litType$:o?._$litType$===t,l=o=>null!=o?._$litType$?.h,c$1=o=>void 0!==o?._$litDirective$,d=o=>o?._$litDirective$,f$1=o=>void 0===o.strings,s$1=()=>document.createComment(""),r$1=(o,i,n)=>{const e=o._$AA.parentNode,l=void 0===i?o._$AB:i._$AA;if(void 0===n){const i=e.insertBefore(s$1(),l),c=e.insertBefore(s$1(),l);n=new t$1(i,c,o,o.options);}else {const t=n._$AB.nextSibling,i=n._$AM,c=i!==o;if(c){let t;n._$AQ?.(o),n._$AM=o,void 0!==n._$AP&&(t=o._$AU)!==i._$AU&&n._$AP(t);}if(t!==l||c){let o=n._$AA;for(;o!==t;){const t=o.nextSibling;e.insertBefore(o,l),o=t;}}}return n},v=(o,t,i=o)=>(o._$AI(t,i),o),u={},m=(o,t=u)=>o._$AH=t,p=o=>o._$AH,h$2=o=>{o._$AP?.(!1,!0);let t=o._$AA;const i=o._$AB.nextSibling;for(;t!==i;){const o=t.nextSibling;t.remove(),t=o;}},j=o=>{o._$AR();};

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t={ATTRIBUTE:1,CHILD:2,PROPERTY:3,BOOLEAN_ATTRIBUTE:4,EVENT:5,ELEMENT:6},e$1=t=>(...e)=>({_$litDirective$:t,values:e});class i{constructor(t){}get _$AU(){return this._$AM._$AU}_$AT(t,e,i){this._$Ct=t,this._$AM=e,this._$Ci=i;}_$AS(t,e){return this.update(t,e)}update(t,e){return this.render(...e)}}

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const s=(i,t)=>{const e=i._$AN;if(void 0===e)return !1;for(const i of e)i._$AO?.(t,!1),s(i,t);return !0},o$1=i=>{let t,e;do{if(void 0===(t=i._$AM))break;e=t._$AN,e.delete(i),i=t;}while(0===e?.size)},r=i=>{for(let t;t=i._$AM;i=t){let e=t._$AN;if(void 0===e)t._$AN=e=new Set;else if(e.has(i))break;e.add(i),c(t);}};function h$1(i){void 0!==this._$AN?(o$1(this),this._$AM=i,r(this)):this._$AM=i;}function n$1(i,t=!1,e=0){const r=this._$AH,h=this._$AN;if(void 0!==h&&0!==h.size)if(t)if(Array.isArray(r))for(let i=e;i<r.length;i++)s(r[i],!1),o$1(r[i]);else null!=r&&(s(r,!1),o$1(r));else s(this,i);}const c=i=>{i.type==t.CHILD&&(i._$AP??=n$1,i._$AQ??=h$1);};class f extends i{constructor(){super(...arguments),this._$AN=void 0;}_$AT(i,t,e){super._$AT(i,t,e),r(this),this.isConnected=i._$AU;}_$AO(i,t=!0){i!==this.isConnected&&(this.isConnected=i,i?this.reconnected?.():this.disconnected?.()),t&&(s(this,i),o$1(this));}setValue(t){if(f$1(this._$Ct))this._$Ct._$AI(t,this);else {const i=[...this._$Ct._$AH];i[this._$Ci]=t,this._$Ct._$AI(i,this,0);}}disconnected(){}reconnected(){}}

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const e=()=>new h;class h{}const o=new WeakMap,n=e$1(class extends f{render(i){return T}update(i,[s]){const e=s!==this.Y;return e&&void 0!==this.Y&&this.rt(void 0),(e||this.lt!==this.ct)&&(this.Y=s,this.ht=i.options?.host,this.rt(this.ct=i.element)),T}rt(t){if(this.isConnected||(t=void 0),"function"==typeof this.Y){const i=this.ht??globalThis;let s=o.get(i);void 0===s&&(s=new WeakMap,o.set(i,s)),void 0!==s.get(this.Y)&&this.Y.call(this.ht,void 0),s.set(this.Y,t),void 0!==t&&this.Y.call(this.ht,t);}else this.Y.value=t;}get lt(){return "function"==typeof this.Y?o.get(this.ht??globalThis)?.get(this.Y):this.Y?.value}disconnected(){this.lt===this.ct&&this.rt(void 0);}reconnected(){this.rt(this.ct);}});

/**
 * @class StoreLocations
 * @description A custom element for rendering a list of pick up locations. This element is used in 2 different contexts: The watch stock and the click and collect. Based on the scope the element will render the correct button for the action.
 * @extends LitElement
 */
class StoreLocations extends s$2 {
  // Reactive properties
  static properties = {
    q: { type: String },
    results: { type: Array },
  };

  /** @type {Boolean} */
  clickAndCollect = this.getAttribute('scope') === 'click-and-collect' || false;

  /** @type {String | null} */
  retailUnityEndPoint = this.getAttribute('retail-unity-endpoint') || null;

  /** @type {String | null}  */
  apiKey = this.getAttribute('api-key') || null;

  /** Vars for the Google Maps API objects */

  /** @type {null} */
  mapsGeocoder = null;

  /** @type {null} */
  geometry = null;

  /** @type {Object} */
  savedLatLng = {};

  connectedCallback() {
    super.connectedCallback();
    this.loadLibraries();

    // Other components we need to interact with
    this.sectionLightbox = this.closest('section-lightbox');
    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.cartItems = document.querySelector('cart-items');

    // Read data
    this.variants = JSON.parse(
      this.closest('[data-section-lightbox="content"]').querySelector(
        'form [type="application/json"]'
      ).textContent || '[]'
    );
    this.stores = JSON.parse(
      this.querySelector('[data-stores][type="application/json"]').textContent || '[]'
    );

    this.variantInventory = JSON.parse(
      this.querySelector('[data-variant-inventory][type="application/json"]').textContent || '[]'
    );

    this.translation = JSON.parse(
      this.querySelector('[data-translations][type="application/json"]')?.textContent || '{}'
    );

    // Set the current variant object
    this.setCurrentVariant();

    // Update variant when variant-select changes
    this.variantSelect = this?.closest('[data-section-lightbox="content"]')?.querySelector(
      'variant-selects'
    );
    this.variantSelect?.addEventListener('variant-change', (event) =>
      this.handleVariantChange(event)
    );

    // Get the current date
    const currentDate = new Date();

    // Get the day of the week (0-6, where 0 is Sunday and 6 is Saturday)
    this.dayOfWeek = currentDate.getDay();

    this.setStoreResults();
  }

  /**
   * loadLibraries
   * @description Loads the google maps api libraries
   * @returns {undefined}
   */
  async loadLibraries() {
    if (!this.apiKey) return;

    const googleMapsLoader = new Loader({
      apiKey: this.apiKey,
      version: 'weekly',
    });

    // Get the needed libraries from the Google Maps API loader and assign for later use
    let [geocoding, geometry] = await Promise.all([
      googleMapsLoader.importLibrary('geocoding'),
      googleMapsLoader.importLibrary('geometry'),
    ]);

    const { Geocoder } = geocoding;
    this.mapsGeocoder = new Geocoder();

    this.geometry = geometry;
    let { spherical } = geometry;
    this.spherical = spherical;
  }

  /**
   * readVariantFromUrl
   * @description Reads the variant from the url
   * @returns {Number} The selected variant id
   */
  readVariantFromUrl() {
    let params = new URLSearchParams(document.location.search);
    let currentVariant = params.get('variant');
    return currentVariant;
  }

  /**
   * handleVariantChange
   * @param {Object} event
   * @returns {Number} The selected variant id
   */
  handleVariantChange(event) {
    const newValue = event.currentTarget?.closest('form')?.querySelector('input[name="id"]')?.value;
    this.currentVariant = this.variants.find((x) => x.id == newValue);
    if (!this.currentVariant) return;

    // Update the price
    this.sectionLightbox.querySelector('#pick-up-product-price').textContent = formatMoney(
      this.currentVariant.price,
      shopMoneyFormat
    );

    // Set the new selected variant in the url
    const searchParams = new URLSearchParams(document.location.search);
    searchParams.set('variant', this.currentVariant.id);
    // Set in history
    history.pushState({}, '', `${window.location.pathname}?${searchParams.toString()}`);
    // Set the correct stores for the selected variant
    this.setStoreResults();
    return this.currentVariant.id;
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setStoreResults();
    this.q?.length > 0
      ? (this.results = [
          ...this.currentVariantStores.filter((store) => this.handleStoreFilter(store)),
        ])
      : (this.results = this.currentVariantStores);
  }

  /**
   * setStoreResults
   * @description Sets the results (stores) based on the current selected variant.
   */
  setStoreResults() {
    const selectedVariant = this.variantInventory.find(
      (variant) => variant.id == this.currentVariant.id
    );

    const storesToRender = selectedVariant.stores.map((store) => {
      return {
        ...store,
        ...this.stores.find((x) => x.handle === store.handle),
      };
    });
    this.currentVariantStores = storesToRender;
    this.results = storesToRender.filter((store) => store.inventory_quantity > 0);
  }

  /**
   * getInputLatLng
   * @param {Object} request
   * @description Get the lat lng from the user input, based on the google maps geocoding api
   * @returns {String[]} The lat and lng coordinates.
   */
  async getInputLatLng(request) {
    try {
      let response = await this.mapsGeocoder.geocode(request);
      const result = response?.results[0];
      const lat = result.geometry.location.lat();
      const lng = result.geometry.location.lng();
      return [lat, lng];
    } catch (error) {
      console.log('Geocode was not successful for the following reason: ' + error);
      return [null, null];
    }
  }

  /**
   * handleInput
   * @description Handles the input and filters the results based on the input or lat lng with the maps geocoding api
   * @url https://developers.google.com/maps/documentation/javascript/geometry#maps_geometry_headings-javascript
   * @param {Object} event
   * @returns {undefined}
   */
  async handleInput(event) {
    this.setStoreResults();
    this.q = this.querySelector('input[name="q"]')?.value;
    // const queryKey = this.q.replace(' ', '-').toLowerCase();

    // Only do something when the input is longer than 3 characters
    this.filterResultsOnText();

    // Only do the external paid call to google when the api settings is active and the results are empty
    if (this.apiKey && this.q?.length > 3 && this.results.length == 0) {
      const [lat, lng] = await this.getInputLatLng({ address: this.q });

      // check if there is a result lat lng, if so filter the results based on lat long
      if (lat && lng) {
        console.log(`Lat: ${lat} Lng: ${lng} found for q: ${this.q}`);
        this.orderResultsOnLatLng(lat, lng);
        return;
      }

      this.results = [];
    }
  }

  /**
   * orderResultsOnLatLng
   * @description Filters the results based on the lat and lng, the closest store to this location will be on top.
   * @param {Number} lat
   * @param {Number} lng
   */
  orderResultsOnLatLng(lat, lng) {
    this.results = [
      ...this.currentVariantStores
        .sort((a, b) => {
          // Need a check to make sure there is a lat and lng from the store
          if (!a.latitude || !a.longitude || !b.latitude || !b.longitude) {
            return 0;
          }

          // Calculate the distance between the input and the store a
          const distanceBetweenInputAndA = this.spherical.computeDistanceBetween(
            { lat: lat, lng: lng },
            { lat: +a.latitude, lng: +a.longitude }
          );

          // Calculate the distance between the input and the store b
          const distanceBetweenInputAndB = this.spherical.computeDistanceBetween(
            { lat: lat, lng: lng },
            { lat: +b.latitude, lng: +b.longitude }
          );

          if (distanceBetweenInputAndA < distanceBetweenInputAndB) {
            return -1;
          }
          if (distanceBetweenInputAndA > distanceBetweenInputAndB) {
            return 1;
          }
          return 0; // Add missing return for equal distances
        })
        .filter((store) => store.inventory_quantity > 0),
    ];
  }

  filterResultsOnText() {
    // continue with the normal string search
    this.q?.length > 0
      ? (this.results = [
          ...this.currentVariantStores.filter((store) => this.handleStoreFilter(store)),
        ])
      : (this.results = this.currentVariantStores.filter((store) => store.inventory_quantity > 0));
  }

  /**
   * handleStoreFilter
   * @param {Object} store
   * @description Callback for the store array filter. Returns the correct stores based on the input type="q"
   * @returns {Boolean}
   */
  handleStoreFilter = (store) => {
    return (
      (store.name?.toLowerCase().includes(this.q.toLowerCase()) && store.inventory_quantity > 0) ||
      (store.address?.toLowerCase().includes(this.q.toLowerCase()) && store.inventory_quantity > 0)
    );
  };

  clearInput(event) {
    event.stopPropagation();
    this.querySelector('input[name="q"]').value = '';
    this.q = '';
    this.results = this.currentVariantStores;
  }

  /**
   * setCurrentVariant
   * @returns {Object} The current variant object
   */
  setCurrentVariant() {
    const formVariantId = this.sectionLightbox?.querySelector('input[name="id"]')?.value;

    this.currentVariant = this.readVariantFromUrl()
      ? this.variants.find((x) => {
          if (x.id == this.readVariantFromUrl()) {
            return x;
          }
        })
      : this.variants.find((variant) => variant.id == formVariantId);
  }

  async handleAction(event, store) {
    event.preventDefault();
    this.loading();
    const button = event.currentTarget;
    button.classList.add('loading');

    let sectionsToFetch = [
      ...this.cartNotification.getSectionsToRender().map((section) => section.section),
    ];
    if (this.cartItems) {
      sectionsToFetch = [
        ...sectionsToFetch,
        ...this.cartItems.getSectionsToRender().map((section) => section.section),
      ];
      // return unique values of array
      sectionsToFetch = [...new Set(sectionsToFetch)];
    }
    let shouldBeClosed = false;
    try {
      const body = {
        items: [
          {
            id: this.currentVariant.id,
            quantity: 1,
            properties: {
              _store_handle: store.handle,
              Store: store.name,
            },
          },
        ],
        sections: sectionsToFetch.join(','),
      };
      const response = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const parsedState = await response.json();

      if (parsedState.status == 422) {
        this.cartNotification.renderCartError(parsedState?.description);
        return;
      } else if (this.cartDrawer) {
        this.cartDrawer?.renderContents(parsedState);
        setTimeout(() => {
          this.cartDrawer.open();
        });
      }

      shouldBeClosed = true;

      document.dispatchEvent(
        new CustomEvent('cart-updated', {
          bubbles: true,
          detail: {
            ...parsedState,
          },
        })
      );
    } catch (error) {
      console.error(error);
    } finally {
      this.loading(false);
      button.classList.remove('loading');
      shouldBeClosed && this.sectionLightbox?.close();
    }
  }

  loading(state = true) {
    state ? this.classList.add('loading') : this.classList.remove('loading');
  }

  render() {
    return x`
      <form @submit=${this.handleSubmit} class="mt-4">
        <label class="mb-2 block text-sm font-medium leading-6">
          ${this.translation.filter_label}
        </label>
        <div class="relative">
          <input
            type="text"
            name="q"
            placeholder=${this.translation.filter_placeholder}
            autocomplete="off"
            class="field__input pl-10 pr-10"
            @keyup=${debounce((event) => {
              this.handleInput(event);
            }, 250)}
          />
          <button
            type="submit"
            class="absolute left-2 top-1/2 block -translate-y-1/2 hover:opacity-60 active:opacity-100"
            @click=${this.handleSubmit}
          >
            ${search_icon}
          </button>
          ${this.q?.length > 0
            ? x`
                <button
                  type="button"
                  class="absolute right-2 top-1/2 -translate-y-1/2 hover:opacity-60 active:opacity-100"
                  @click=${this.clearInput}
                >
                  ${back_icon}
                </button>
              `
            : null}
        </div>
        <!-- <button type="submit" class="button button--blue mt-4">
          ${this.translation.filter_button}
        </button> -->
      </form>
      ${this.results?.length
        ? x`
            <p class="mb-4 mt-8 text-sm font-bold uppercase leading-4">
              ${this.translation.results_label}
            </p>
            <ul class="space-y-4">
              ${this.results.map(
                (result) => x`
                  <li class="bg-gray-200 p-4">
                    <div class="mb-4 flex items-start justify-between gap-x-3">
                      <p
                        class="flex-auto hyphens-auto break-words text-sm font-medium uppercase leading-6"
                      >
                        ${result.name || result.short_name || result.handle}
                      </p>
                      <p class="flex-none text-xs font-bold leading-3 text-red">
                        ${result.inventory_quantity} ${this.translation.x_in_stock}
                      </p>
                    </div>

                    <div class="space-y-3">
                      ${result.address
                        ? x`
                            <a
                              href=${result.directions}
                              target="_blank"
                              rel="noopener noreferrer"
                              class="relative block min-h-6 py-1 pl-6 text-xs leading-4 text-inherit"
                            >
                              <span class="absolute left-0 top-1/2 block w-4 -translate-y-1/2">
                                ${location_icon}
                              </span>
                              ${result.address}
                            </a>
                          `
                        : null}
                      <details class="group appearance-none bg-none">
                        <summary
                          class="relative flex min-h-6 cursor-pointer py-1 pl-6 text-xs leading-4 text-inherit marker:hidden"
                        >
                          <span class="absolute left-0 top-1/2 block w-4 -translate-y-1/2">
                            ${clock_icon}
                          </span>
                          <span>
                            ${this.translation.opening_hours_today}
                            ${[
                              result.opening_hours_sunday,
                              result.opening_hours_monday,
                              result.opening_hours_tuesday,
                              result.opening_hours_wednesday,
                              result.opening_hours_thursday,
                              result.opening_hours_friday,
                              result.opening_hours_saturday,
                            ][this.dayOfWeek]}
                          </span>
                          <span
                            class="-my-1 ml-2 inline-block w-6 self-start transition-transform group-open:-rotate-180"
                            >${chevron_down_icon}</span
                          >
                        </summary>
                        <dl class="grid grid-cols-4 gap-x-1 gap-y-2 pl-6 pt-2 text-xs leading-4">
                          <dt class="col-span-1">${this.translation.monday}</dt>
                          <dd class="col-span-3">${result.opening_hours_monday || '-'}</dd>

                          <dt class="col-span-1">${this.translation.tuesday}</dt>
                          <dd class="col-span-3">${result.opening_hours_tuesday || '-'}</dd>

                          <dt class="col-span-1">${this.translation.wednesday}</dt>
                          <dd class="col-span-3">${result.opening_hours_wednesday || '-'}</dd>

                          <dt class="col-span-1">${this.translation.thursday}</dt>
                          <dd class="col-span-3">${result.opening_hours_thursday || '-'}</dd>

                          <dt class="col-span-1">${this.translation.friday}</dt>
                          <dd class="col-span-3">${result.opening_hours_friday || '-'}</dd>

                          <dt class="col-span-1">${this.translation.saturday}</dt>
                          <dd class="col-span-3">${result.opening_hours_saturday || '-'}</dd>

                          <dt class="col-span-1">${this.translation.sunday}</dt>
                          <dd class="col-span-3">${result.opening_hours_sunday || '-'}</dd>
                        </dl>
                      </details>
                      ${result.phone
                        ? x`
                            <p>
                              <a
                                href=${`tel:${result.phone}`}
                                class="relative block min-h-6 py-1 pl-6 text-xs leading-4 text-inherit"
                              >
                                <span class="absolute left-0 top-1/2 block w-4 -translate-y-1/2">
                                  ${phone_icon}
                                </span>
                                ${result.phone}
                              </a>
                            </p>
                          `
                        : null}
                      ${result.mail
                        ? x`
                            <p>
                              <a
                                href=${`mailto:${result.mail}`}
                                class="relative block min-h-6 py-1 pl-6 text-xs leading-4 text-inherit underline"
                              >
                                <span class="absolute left-0 top-1/2 block w-4 -translate-y-1/2">
                                  ${mail_icon}
                                </span>
                                ${result.mail}
                              </a>
                            </p>
                          `
                        : null}
                      <div>
                        ${this.clickAndCollect
                          ? result.id != null
                            ? x`
                                <retail-unity-click-and-reserve
                                  .store=${result}
                                  .currentVariant=${this.currentVariant}
                                  .translation=${this.translation}
                                  .retailUnityEndPoint=${this.retailUnityEndPoint}
                                ></retail-unity-click-and-reserve>
                              `
                            : null
                          : null}
                      </div>
                    </div>
                  </li>
                `
              )}
            </ul>
          `
        : null}
      ${this.results?.length == 0
        ? x`<p class="mt-8">${this.translation.no_stores_found}</p>`
        : null}
    `;
  }

  /**
   * @description Render in DOM not shadow DOM
   * @returns {Element} The render root
   */
  createRenderRoot() {
    return this;
  }
}

customElements.define('store-locations', StoreLocations);

/**
 * @class RetailUnityClickAndReserve
 * @extends LitElement
 * @description A component that allows a user to click and reserve a product from a store
 */
class RetailUnityClickAndReserve extends s$2 {
  static properties = {
    loading: { type: Boolean },
    open: { type: Boolean },
    store: { type: Object },
    currentVariant: { type: Object },
    retailUnityEndPoint: { type: String },
    success: { type: Boolean },
    errorMessage: { type: String },
    translation: { type: Object },
  };

  inputRef = e();

  connectedCallback() {
    super.connectedCallback();
    this.success = false;
  }

  async handleRetailUnityAction(event) {
    event.preventDefault();
    this.loading = true;

    const formData = new FormData(event.currentTarget);
    const body = Object.fromEntries(formData);
    try {
      this.errorMessage = '';
      const response = await fetch(this.retailUnityEndPoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        this.errorMessage =
          window.triton_x?.api?.[data.code] ||
          data?.message ||
          'An error occurred! Please try again.';
        throw new Error('Error occurred!');
      }

      if (data?.status !== 'success') {
        this.errorMessage = window.triton_x.error || 'An error occurred! Please try again.';
        throw new Error('No success!');
      }

      this.success = true;
      setTimeout(() => {
        this.success = false;
        this.open = false;
      }, 5000);
    } catch (error) {
      console.error(error);
      this.errorMessage = this.translation.error_message;
    } finally {
      this.loading = false;
    }
  }

  updated() {
    if (this.open) {
      const input = this?.inputRef?.value;
      input?.focus();
    }
  }

  render() {
    return x`
      <div>
        ${this.open && !this.success
          ? x` <form
              class="bg-gray-300 p-6"
              @submit=${(event) => {
                this.handleRetailUnityAction(event);
              }}
            >
              <input type="hidden" name="sku" value=${this.currentVariant.sku} />
              <input
                type="hidden"
                name="price"
                value=${formatMoney(this.currentVariant.price, shopMoneyFormat)}
              />
              <input type="hidden" name="store" value=${this.store.id} />
              <p class="mb-4">${this.translation.book_here_description}</p>
              <div class="field mb-4">
                <input
                  type="text"
                  name="name"
                  .placeholder=${this.translation.name || ''}
                  required
                  class="field__input border border-gray"
                  ${n(this.inputRef)}
                />
              </div>
              <div class="field mb-4">
                <input
                  type="email"
                  name="email"
                  .placeholder=${this.translation.email || ''}
                  required
                  class="field__input border border-gray"
                />
              </div>
              <div class="field mb-4">
                <input
                  type="tel"
                  name="phone"
                  .placeholder=${this.translation.phone || ''}
                  minlength="10"
                  required
                  class="field__input border border-gray"
                />
              </div>
              ${this.errorMessage &&
              x`
                <div
                  class="mb-4 rounded-sm border border-red-dark bg-red/80 px-4 py-2 text-white empty:hidden"
                >
                  ${this.errorMessage}
                </div>
              `}
              <button
                type="submit"
                class=${`button button--blue ${this.loading ? `loading` : ''}`}
                ?disabled=${this.loading}
              >
                ${this.translation.book}
              </button>
            </form>`
          : null}
        ${this.success
          ? x`<p
              class="border-success-dark rounded-sm border bg-success/80 px-4 py-2 text-white empty:hidden"
            >
              ${this.translation.book_success}
            </p>`
          : null}
        <button
          type="button"
          class="button button--blue aria-hidden:hidden"
          @click=${() => {
            this.open = !this.open;
          }}
          ?disabled=${this.store.inventory_quantity < 1}
          aria-hidden=${this.open}
        >
          ${this.store.inventory_quantity > 0
            ? x`${this.translation.book_here}`
            : x`${this.translation.sold_out}`}
        </button>
      </div>
    `;
  }

  createRenderRoot() {
    return this;
  }
}

customElements.define('retail-unity-click-and-reserve', RetailUnityClickAndReserve);
